import { OptionSubCategory } from 'owa-options-core';
import SharePbpOption from 'owa-pbp-option/lib/SharePbpOption';
import PublishPbpOption from 'owa-pbp-option/lib/PublishPbpOption';
import MeetingTypesPbpOption from 'owa-pbp-option/lib/MeetingTypesPbpOption';
import initPbpSettings from 'owa-pbp-option/lib/orchestration/initPbpSettings';

let pbpSubCategory: OptionSubCategory = {
    key: 'pbp',
    titleStringKey: 'optionSubcategory_pbp',
    options: [PublishPbpOption, SharePbpOption, MeetingTypesPbpOption],
    onSelected: initPbpSettings,
};

export default pbpSubCategory;
